import styled from "styled-components";

import { T_TITLE_4 } from "../../global.style";

const dayInputWidth = 34;

export const CalendarGrid = styled.div<{
    $rowLength: number
}>`
    display: grid;
    grid-gap: 12px;
    grid-template-columns: ${props => `repeat(${props.$rowLength}, 1fr)`};
`;

export const DayLabel = styled.div`
    text-transform: uppercase;
    ${T_TITLE_4};
    text-align: center;
    width: ${dayInputWidth} px;
    margin-bottom: -10px;
`;